/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Hint_TextInputs */

const en_matching_score_hint_text = /** @type {(inputs: Matching_Score_Hint_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You will receive feedback on the fit with the position in the next step via the Matching Score.`)
};

const de_matching_score_hint_text = /** @type {(inputs: Matching_Score_Hint_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback zur Passung zur Stelle erhältst du im nächsten Schritt über den Matching Score.`)
};

/**
* | output |
* | --- |
* | "You will receive feedback on the fit with the position in the next step via the Matching Score." |
*
* @param {Matching_Score_Hint_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_hint_text = /** @type {((inputs?: Matching_Score_Hint_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Hint_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_hint_text(inputs)
	return en_matching_score_hint_text(inputs)
});